export default __webpack_public_path__ + "static/media/gif2_slow.7867e7c3.gif";